export default __webpack_public_path__ + "static/razorpay-1c7df6dc7e1a1d59feb3ae7307c1bc9c.png";